
<template>
    <Teleport to="body">
        <transition name="fade">
            <div v-show="showCalendarSearch" @click="closecalendarSearch" ref="calendarBG" id="calendarBG"
                @keydown.esc="closeCalendarSearch"
                class="bg-gray-200 bg-opacity-80 dark:bg-neutral-900 dark:bg-opacity-75 backdrop-blur-lg z-50 fixed top-0 left-0 h-full w-full py-8 pt-4 overflow-y-scroll overflow-x-hidden scrollbar-hide animate-in fade-in ease-in-out duration-800 big_calendar js_close_clickable"
                :class="{ 'loadingDates': loadingCalendar }">
                <div class="w-full px-4 md:px-8 flex flex-col justify-center js_close_clickable pb-4">
                    <div class="w-full flex justify-between  js_close_clickable">
                        <button type="button" @click="switchToLocation"
                            class="text-gray-500 mt-5 mb-2 group font-medium text-sm px-4 rounded-full duration-500 ease-in-out py-2.5 mr-auto mr-auto sm:ml-0 text-center inline-flex items-center transition cursor-pointer hover:bg-white">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 mr-2" fill="currentColor"
                                viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                <path
                                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                            </svg>
                            {{ $t('Select Location') }}
                        </button>
                        <button type="button" @click="switchToGuests" v-if="useguests"
                            class="text-gray-500 mt-5 mb-2 group font-medium text-sm px-4 rounded-full duration-500 ease-in-out py-2.5 ml-auto mr-0 text-center inline-flex items-center transition cursor-pointer hover:bg-white">
                            {{ $t('Select Guests') }}
                            <svg class="w-3.5 h-3.5 ml-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 14 10">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M1 5h12m0 0L9 1m4 4L9 9" />
                            </svg>
                        </button>
                    </div>

                    <div v-if="notAvailable || loadingCalendar || location && location != null"
                        class="flex gap-4 flex-col items-center justify-center md:flex-row w-full lg:-mt-[50px] pb-0 md2:pb-4 js_close_clickable pointer-events-none">
                        <div v-if="notAvailable"
                            class="bg-red-200 text-red-800 group font-medium text-xs px-4 pl-3 rounded-full duration-500 ease-in-out py-2.5 text-center inline-flex items-center transition">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill=currentColor
                                viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                <path
                                    d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
                            </svg>
                            <span>{{ $t('No availability in the selected dates') }}</span>
                        </div>
                        <div v-if="loadingCalendar"
                            class="bg-primary-lighter text-primary-dark group font-medium text-xs px-4 pl-3 rounded-full duration-500 ease-in-out py-2.5 text-center inline-flex items-center transition">
                            <div class="inline-block h-5 w-5 mr-2 animate-spin rounded-full border-4 border-solid border-primary-dark border-current !border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                                role="status">
                                <span
                                    class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                            </div>
                            <span>{{ $t('Loading availability and prices') }}: {{ location.name }}</span>
                        </div>
                        <div v-else-if="location && location != null" @click="switchToLocation"
                            class="bg-gray-300 group font-medium text-xs px-4 pl-3 rounded-full duration-500 ease-in-out py-2.5 text-center inline-flex items-center transition cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill=currentColor
                                viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                                <path
                                    d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                            </svg>
                            <span>{{ $t('Showing availability for') }}: {{ location.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="px-4 md:px-8 js_close_clickable">
                    <div
                        class="bg-white py-8 max-w-screen-xl mx-auto rounded-md w-full border-gray-300 animate-in slide-in-from-left fade-in ease-in-out duration-300 shadow-2xl ">
                        <div
                            class="w-full flex flex-col md:flex-row gap-4 text-center items-center justify-center text-xs mb-4">
                            <div class="flex gap-2 items-center">
                                <div class="h-2 w-4 rounded-full bg-primary block">
                                </div>
                                <div class="">
                                    {{ $t('Selected') }}
                                </div>
                            </div>
                            <div class="flex gap-2 items-center">
                                <div class="h-2 w-4 rounded-full bg-[#afff8e] block">
                                </div>
                                <div class="">
                                    {{ $t('Available') }}
                                </div>
                            </div>
                            <div class="flex gap-2 items-center">
                                <div class="h-2 w-4 rounded-full bg-[#f4f7f8] border border-[#60b83b] block">
                                </div>
                                <div class="">
                                    {{ $t('Not Available') }}
                                </div>
                            </div>
                        </div>
                        <input type="hidden" id="datepickr_cal" name="checkin-out-cal" />

                        <HotelDatePicker class="px-2 md:px-8 grid animate-in fade-in" ref="hoteldatesform"
                            :alwaysVisible="true"
                            :i18n="'datepicker' in $i18n.messages[$i18n.locale] ? $i18n.messages[$i18n.locale]['datepicker'] : $i18n.messages[$i18n.fallbackLocale]['datepicker']"
                            :disabledDates="unavailable" :periodDates="periodDates" :priceSymbol="'€'" :showPrice="true"
                            :format="dateFormat" :hoveringTooltip="false" :lastDateAvailable="lastDateAvailable"
                            :showYear="true" :firstDayOfWeek="1" :halfDay="true" :minNights="roomMinNights"
                            :selectForward="true" :startingDateValue="new Date(checkIn)" :maxNights="maxNights"
                            :endingDateValue="new Date(checkOut)" @check-in-selected="checkInChange"
                            @dayClicked="handleDayClick" @period-selected="getSelectedDate" @next-month-rendered="nextMonth"
                            @previous-month-rendered="lastMonth" @enter-day="hoverDay">
                        </HotelDatePicker>

                    </div>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<script>
const { debounce } = require("lodash");
import HotelDatePicker from "vue-hotel-datepicker";
import "vue-hotel-datepicker/dist/vueHotelDatepicker.css";
import Helpers from "../../helpers";
import moment from "moment";
import VueCookies from 'vue-cookies';

export default {
    components: {
        HotelDatePicker,
    },
    name: 'searchCheckInOut',
    props: {
        activeWindow: {},
        lastDateAvailable: {
            type: [Number, Date],
            default: Infinity,
        },
        listingSlug: {
            type: String,
            default: ''
        }
    },
    mounted() {
        const clientVars = this.$attrs.clientvariables ? JSON.parse(this.$attrs.clientvariables) : {};
        this.useguests = clientVars.useguests == "1" ? true : false;

        this.$root.$on("showCalendarSearch", (msg) => {
            $("body").addClass("scroll_lock")
            this.$refs.calendarBG.focus();
            this.showCalendarSearch = msg;
        });

        this.$root.$on("locationChange", (msg) => {
            this.unavailable = [];
            this.accoUnavailable = [];
            this.periodDates = [];
            this.maxNights = null;

            var location = VueCookies.get('searchlocation');
            if (location && location != 'null') {
                this.location = location;
                if (location.hasOwnProperty('nonHome')) {
                    this.searchlocation = location.nonHome + '=' + location.name;
                } else {
                    this.searchlocation = 'propID=' + location.id;
                }
            } else {
                this.location = null;
                this.searchlocation = null;
            }
            this.getData();
            // this.forceRender();
        });
    },
    filters: {
        smallDate: function (date) {
            return moment(date).format('Do MMM');
        }
    },
    data() {
        return {
            previousTitle: '',
            showCalendarSearch: false,
            roomMinNights: 1,
            checkIn: null,
            checkOut: null,
            loadingCalendar: false,
            notAvailable: false,
            checkInTemp: null,
            checkOutTemp: null,
            clickedDate: null,
            search: new URLSearchParams(window.location.search),
            nextDisabledDate: null,
            roomMinNights: 1,
            setMax: false,
            location: null,
            useguests: true,
            maxNights: null,
            maxNightsTemp: null,
            gottenCheckin: null,
            gottenCheckout: null,
            selectActive: false,
            data: [],
            accoUnavailable: [],
            unavailable: [],
            nextunavailable: [],
            periodDates: [],
            prices: [],
            dataloaded: false,
            getDataCheckin: moment(),
            getDataCheckout: moment().add(1, 'M').endOf('month'),
            renderComponent: true,
        };
    },
    methods: {
        ...Helpers,
        closecalendarSearch(e) {
            if (e.target.classList.contains('js_close_clickable') || e.key == "Escape") {
                this.showCalendarSearch = false;
                setTimeout(function () {
                    $("body").removeClass("scroll_lock")
                }, 350);
            }
        },
        switchToLocation() {
            this.showCalendarSearch = false
            this.$root.$emit("showLocationSearch", true);
        },
        switchToGuests() {
            this.showCalendarSearch = false
            this.$root.$emit("showGuestsSearch", true);
        },
        async forceRender() {
            this.renderComponent = false;
            await this.$nextTick();
            this.renderComponent = true;
        },
        nextMonth(event) {
            this.loadingCalendar = true;
            this.getDataCheckin = moment(event).startOf('month');
            this.getDataCheckout = moment(event).endOf('month');
            this.fetch();
        },
        lastMonth(event) {
            this.loadingCalendar = true;
            this.getDataCheckin = moment(event).startOf('month');
            this.getDataCheckout = moment(event).endOf('month');
            this.fetch();
        },
        calculateMaxNights: _.debounce(function (date) {
            let nextDisabledDate =
                this.getNextDate(this.unavailable, date) ||
                Infinity;

            var maximumNights = this.getDayDiff(date, nextDisabledDate)
            if (!maximumNights) {
                this.maxNights = null;
            } else {
                this.maxNights = maximumNights + 1
            }
        }, 100),
        hoverDay(event, date) {
            if (!event.sourceCapabilities.firesTouchEvents && !this.selectActive) {
                this.calculateMaxNights(date.date)
            }
        },
        checkInChange(event) {
            this.selectActive = true;
            this.clickedDate = new Date(event)
        },
        getSelectedDate(event, checkinDate, checkoutDate) {
            this.notAvailable = false
            this.loadingCalendar = false;
            this.selectActive = false
            this.checkIn = checkinDate;
            this.checkOut = checkoutDate;
            VueCookies.set('checkin', moment(checkinDate).format(this.dateFormat));
            VueCookies.set('checkout', moment(checkoutDate).format(this.dateFormat));
            this.$root.$emit("checkinSelect", moment(checkinDate).format(this.dateFormat));
            this.$root.$emit("checkoutSelect", moment(checkinDate).format(this.dateFormat));

            if (this.useguests) {
                this.showCalendarSearch = false
                this.$root.$emit("showGuestsSearch", true);
            } else {
                var url = this.$homeUrl + '/accomodations?';
                if (this.listingSlug) {
                    url = this.$homeUrl + '/' + this.listingSlug + '?';
                }
                if (VueCookies.get('checkin')) {
                    url = url + 'checkin=' + moment(VueCookies.get('checkin')).format('YYYYMMDD')
                }
                if (VueCookies.get('checkout')) {
                    url = url + '&checkout=' + moment(VueCookies.get('checkout')).format('YYYYMMDD')
                }
                if (VueCookies.get('searchlocation')) {
                    var location = VueCookies.get('searchlocation');
                    if (location.hasOwnProperty('nonHome')) {
                        url = url + '&' + encodeURIComponent(location.nonHome) + '=' + encodeURIComponent(location.name);
                    } else {
                        url = url + '&name=' + encodeURIComponent(location.name);
                    }
                }

                window.location.href = url;
            }
        },
        async getData() {
            try {
                if (this.searchlocation) {
                    this.loadingCalendar = true;
                    this.notAvailable = false;
                    let response = await fetch(
                        this.$BMB_API + 'api/' +
                        this.$clientID +
                        "/getCalendar?" + this.searchlocation + "&checkin=" + this.getDataCheckin.format('YYYY-MM-DD') + "&checkout=" + this.getDataCheckout.format('YYYY-MM-DD'),
                        {
                            headers: {
                                "Content-Type": "text/plain",
                            },
                        }
                    );

                    this.data = await response.json();
                    this.dataloaded = true;

                    this.unavailable.push(...this.data.unavailable);
                    this.accoUnavailable.push(...this.data.unavailable)
                    this.periodDates.push(...this.data.periodDates);

                    if (this.checkIn && this.checkOut && this.accoUnavailable) {

                        var startDate = moment(this.checkIn);
                        var dates = []
                        var safeGuard = 0;
                        while (startDate < this.checkOut) {
                            safeGuard += 1;
                            dates.push(startDate.format('YYYY-MM-DD'));
                            startDate.add(1, 'days');
                            if (safeGuard >= 100) {
                                console.log("Safeguard saved the day, check your dates!")
                                break;
                            }
                        }
                        if (dates.some(r => this.unavailable.includes(r))) {
                            this.notAvailable = true;
                        }
                    }
                    this.loadingCalendar = false;

                    if (!this.gottenCheckin || this.getDataCheckin < this.gottenCheckin) {
                        this.gottenCheckin = this.getDataCheckin;
                    }
                    if (!this.gottenCheckout || this.getDataCheckout < this.gottenCheckout) {
                        this.gottenCheckout = this.getDataCheckout;
                    }
                }
            } catch (error) {
                this.loadingCalendar = false;
                console.log(error);
            }
        },
        handleDayClick(event, date, formatDate, resetCheckin) {

            this.nextPeriodDisableDates = [];
            this.setMax = true;

            if (resetCheckin) {
                this.clearSelection();
                this.$nextTick(() => {
                    this.handleDayClick(event, date, formatDate, false);
                });
                this.unavailable = this.accoUnavailable;
                return;
            }
        },
        fetch: _.debounce(function () {
            this.getData()
        }, 500),
    },
    created() {
        moment.locale(document.documentElement.lang);
        if (this.search.get('checkin') && this.search.get('checkout')) {
            this.checkIn = moment(this.search.get('checkin'))
            this.checkOut = moment(this.search.get('checkout'))
            this.$emit("checkinSelect", moment(this.checkIn).format(this.dateFormat));
            this.$emit("checkoutSelect", moment(this.checkOut).format(this.dateFormat));
        }
        if (VueCookies.get('checkin') && VueCookies.get('checkout')) {
            this.checkIn = moment(VueCookies.get('checkin'))
            this.checkOut = moment(VueCookies.get('checkout'))
            this.$emit("checkinSelect", moment(this.checkIn).format(this.dateFormat));
            this.$emit("checkoutSelect", moment(this.checkOut).format(this.dateFormat));
            this.getDataCheckin = moment(VueCookies.get('checkin')).startOf('month');
            this.getDataCheckout = moment(VueCookies.get('checkin')).add(1, 'M').endOf('month');
        }
        if (VueCookies.get('searchlocation')) {
            var location = VueCookies.get('searchlocation');
            if (location && location != 'null') {
                this.location = location;
                if (location.hasOwnProperty('nonHome')) {
                    this.searchlocation = location.nonHome + '=' + location.name;
                } else {
                    this.searchlocation = 'propID=' + location.id;
                }
            } else {
                this.location = null;
                this.searchlocation = null;
            }
        }
        this.fetch();
    },
    computed: {
        dateFormat() {
            return "YYYY-MM-DD";
        },
    }
}
</script>